import styled from "@emotion/styled"

export const Image = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`